import { Box } from '@mui/system';
import styled from '@mui/system/styled';

export const ContentCnt = styled('div')({
  width: 'auto', // Allow for dynamic width based on content
  maxHeight: '85vh',
  overflow: 'auto',
  '& label': {
    padding: 0,
    margin: 0,
    '& .content': {
      fontSize: 13,
    },
  },
  // Custom scrollbar styling
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#c1c1c1',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#a1a1a1',
  },
});

export const Title = styled('div')({
  fontSize: 20,
  color: 'black',
  padding: '15px 0px 15px 30px',
  fontWeight: 600,
  borderBottom: '1px solid lightgray',
  marginBottom: 10,
});

export const CoverImageContainer = styled('div')({
  width: '100%',
  height: '220px',
  overflow: 'hidden',
  borderRadius: '16px',
  marginBottom: '24px',
  cursor: 'pointer',
});

export const CoverImage = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
});

export const SignatureCanvasWrapper = styled('div')({
  border: '1px dashed #ccc',
  borderRadius: '4px',
  backgroundColor: '#f9f9f9',
  position: 'relative',
  '& .signature-canvas': {
    width: '100%',
    height: '100%',
  },
});

export const PhotoGrid = styled('div')({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
  gap: '12px',
  marginTop: '12px',
  marginBottom: '12px',
});

export const PhotoItem = styled('div')({
  position: 'relative',
  paddingTop: '100%', // 1:1 Aspect ratio
  backgroundColor: '#f1f1f1',
  borderRadius: '4px',
  overflow: 'hidden',
  '& img': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});

export const VideoPreview = styled('div')({
  position: 'relative',
  width: '100%',
  paddingTop: '56.25%', // 16:9 aspect ratio
  backgroundColor: '#000',
  borderRadius: '4px',
  overflow: 'hidden',
  marginBottom: '12px',
  '& video': {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
});

export const AttachmentItem = styled('div')({
  display: 'flex',
  alignItems: 'center',
  padding: '8px 16px',
  borderRadius: '4px',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
    cursor: 'pointer',
  },
});

export const AttachmentIcon = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '40px',
  height: '40px',
  marginRight: '12px',
  color: '#5f6368',
});

export const ActionButton = styled('button')({
  padding: '8px 16px',
  borderRadius: '4px',
  border: '1px solid #e0e0e0',
  backgroundColor: 'white',
  cursor: 'pointer',
  fontSize: '14px',
  fontWeight: 500,
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
  '&:disabled': {
    opacity: 0.6,
    cursor: 'not-allowed',
  },
});
export const Requirments = styled(Box)({
  padding: '8px 16px',
  borderRadius: '4px',
  boxShadow: '0px 4px 8px 0px #49A5CF29',
  border: '1px solid #81D4FA',
  backgroundColor: '#E1F5FE',
});

export const pinnedContainer = {
  backgroundColor: '#EF6C00',
  padding: '4px',
  borderRadius: '24px',
  marginTop: '4px',
  width: '76px',
  height: '28px',
  alignItems: 'center',
  justifyContent: 'center',
  display: 'flex',
};

export const pinnedText = {
  fontSize: 12,
  color: 'white',
  fontWeight: 500,
  marginLeft: '4px',
};
export const announcementDescription = {
  '& ul, & ol': {
    paddingLeft: '20px',
    margin: '8px 0',
    display: 'block',
  },
  '& ul li, & ol li': {
    display: 'list-item',
    margin: '4px 0',
  },
  '& ul li': {
    listStyleType: 'disc',
  },
  '& ol li': {
    listStyleType: 'decimal',
  },
  '& em': {
    fontStyle: 'italic',
  },
  '& strong': {
    fontWeight: 'bold',
  },
  '& u': {
    textDecoration: 'underline',
  },
  '& s': {
    textDecoration: 'line-through',
  },
  '& a': {
    textDecoration: 'underline',
    color: '#1976d2',
  },
};
